import { GET_ORGANIZATION, ADD_ORGANIZATION, PUT_ORGANIZATION, GET_ORG_COMPANIES } from '../types'

const INITIAL_STATE = {
  allOrganisations: [],
  putOrganisation: [],
  orgCompanies: {}
}

const organizationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION:
      return {
        ...state,
        allOrganisations: payload.data,
      }
    case ADD_ORGANIZATION:
      return {
        ...state,
        addOrganisation: payload,
      }
    case PUT_ORGANIZATION:
      return {
        ...state,
        putOrganisation: payload.data,
      }
    case GET_ORG_COMPANIES:
      return {
        ...state,
        orgCompanies: payload.data
      }
    default:
      return state
  }
}

export default organizationReducer
